import { getCountKeySetDataUtil, updateCountSetDataUtil } from '../../../model/utils'
import updateSetWorkoutExerciseAction from '../update-set'
import { getCurrentSetWorkoutExerciseSelect } from '../../selectors/get-current-set'

function updateSetCountValueWorkoutExerciseAction (value) {
  return (dispatch, getState) => {
    let set = getCurrentSetWorkoutExerciseSelect(getState())
    set = updateCountSetDataUtil(set, value)
    dispatch(updateSetWorkoutExerciseAction({
      set,
      key: getCountKeySetDataUtil(set)
    }))
  }
}

export { updateSetCountValueWorkoutExerciseAction }
